export { default } from './MultiSliderCalculator';
export type { IMultiSliderCalculator } from './types';
